import { render, staticRenderFns } from "./MenuBar.vue?vue&type=template&id=5a0bca2c"
import script from "./MenuBar.vue?vue&type=script&lang=js"
export * from "./MenuBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/share/nginx/html/staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a0bca2c')) {
      api.createRecord('5a0bca2c', component.options)
    } else {
      api.reload('5a0bca2c', component.options)
    }
    module.hot.accept("./MenuBar.vue?vue&type=template&id=5a0bca2c", function () {
      api.rerender('5a0bca2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MenuBar.vue"
export default component.exports